<template>
  <v-card flat tile class="elevation-2">
    <v-card color="primary" class="elevation-0 text-left">
      <v-card-title class="px-4 py-3">
        <v-layout row wrap>
          <v-flex xs12 sm12 md8 lg8>
            <h2 class="text-white headline font-weight-bold mt-1">Security</h2>
            <p class="text-white subtitle-2 mb-0">Basic regarding your login</p>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 class="text-md-right text-left">

            <v-tooltip top  v-if="!edit">
              <template v-slot:activator="{ on }">
                <v-btn
                  depressed
                  @click="edit = true"
                  fab 
                  dark 
                  color="white"
                  v-on="on"
                >
                  <v-icon dark class="primary--text">edit</v-icon>
                </v-btn>
              </template>
              <span>Edit password</span>
            </v-tooltip>

             <template v-else>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    depressed
                    @click="resetPasswordForm()"
                    fab 
                    dark 
                    color="white"
                    v-on="on"
                    :class="'mr-2'"
                  >
                    <v-icon dark class="primary--text">close</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    depressed
                    @click="updatePassword()"
                    fab 
                    dark 
                    color="white"
                    v-on="on"
                    :class="'mr-2'"
                  >
                    <v-icon dark class="primary--text">check</v-icon>
                  </v-btn>
                </template>
                <span>Update Info</span>
              </v-tooltip>
            </template>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>

    <!-- content --> 
    <v-form ref="updatePasswordForm" lazy-validation class="px-4 py-4">
      <v-flex xs12>
        <v-text-field
          v-model="password.current_password"
          :rules="fieldRequired"
          :disabled="!edit"
          label="Password"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 v-if="edit">
        <v-text-field
          v-model="password.new_password"
          :rules="passwordRules"
          label="New Password"
          :type="showNewPassword ? 'text' : 'password'"
          :append-icon="showNewPassword ? 'visibility_off' : 'visibility'"
          @click:append="showNewPassword = !showNewPassword"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 v-if="edit">
        <v-text-field
          v-model="password.confirm_new_password"
          label="Confirm New Password"
          :rules="passwordConfirmationRules"
          autocomplete="off"
          :type="showConfirmNewPassword ? 'text' : 'password'"
          :append-icon="showConfirmNewPassword ? 'visibility_off' : 'visibility'"
          @click:append="showConfirmNewPassword = !showConfirmNewPassword"
        ></v-text-field>
      </v-flex>
    </v-form>
    <v-flex xs12 class="px-4">
        <p class="font-weight-bold text-left">2 Factor Authentication</p>
        <v-switch
          color="primary"
          v-model="two_factor"
          @change="updateTwofactorAuth()"
        ></v-switch>
      </v-flex>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import { isEmpty } from 'lodash';

export default {

  data() {
    return {
      showPassword: false,
      showNewPassword: false,
      showConfirmNewPassword: false,
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(v) || 'Password must have 1 capital, 1 number, 1 special letter and more than 8 characters',
      ],
      passwordCheckRules: [
        v => !!v || 'Password is required',
        v => v === this.form.new_password || 'Passwords must match',
      ],
      edit: false,
      two_factor: false,
      form: {
        first_name: '',
        last_name: '',
        phone: '',
      },
      password: {
        current_password: '',
        new_password: '',
        confirm_new_password: '',
      },
    };
  },

  computed: {
    ...mapGetters({
      basicInformation: 'setting/basicInformation',
    }),
    passwordConfirmationRules() {
      return [
        () => (this.password.new_password === this.password.confirm_new_password) || 'Password Mismatch',
        v => !! v || 'Password confirmation is required'
      ];
    },
  },
 watch: {
   basicInformation(val) {
    if(!_.isEmpty(val)) {
      this.two_factor = val.two_factor;
    }
   }
 },
  mounted() {
    if(!_.isEmpty(this.basicInformation)) {
      this.two_factor = this.basicInformation.two_factor;
    }
  },
  methods: {
    /**
     * Reset form
     */
    resetPasswordForm() {
      this.edit = false;
      this.$refs.updatePasswordForm.reset();
    },
    /**
     * Update 2 factor auth
     */
    updateTwofactorAuth() {
      this.spinner(true);
      const url = `${Env.url}/api/v1/users`;
      AuthApi.patchApi(url, {
        two_factor: this.two_factor
      })
      .then((res) => {
        this.getUserInfos();
        this.snackbar({
          text: res.data.msg,
          timeout: 4000,
          open: true,
        });
        this.spinner(false);
      })
      .catch((err) => {
        this.spinner(false);
        this.snackbar({
          text: err.response.data.msg,
          timeout: 4000,
          open: true,
        });
      });
    },

    /**
     * Update password
     */
    updatePassword() {
      if (this.$refs.updatePasswordForm.validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/users/password/update`;
        AuthApi.postApi(url, this.password)
        .then((res) => {
          this.$refs.updatePasswordForm.reset();
          this.edit = false;
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
          this.spinner(false);
        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
        });
      }
    },

    /**
     * Get all users for business
     */
    getUserInfos() {
      const url = `${Env.url}/api/v1/users/me`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setInvitationList(res.data.invitations);
        this.setBasicInformationList(res.data.user);
      })
      .catch((err) => {
        console.log(err.response.data.msg);
      });
    },


    ...mapActions({
      snackbar: 'snackbar/snackbar',
      spinner: 'spinner/spinnerStatus',
       setInvitationList: 'setting/setInvitationList',
      setBasicInformationList: 'setting/setBasicInformationList',
    }),
  },
};
</script>